(ns app.domain.fee.validate
  "Concerns validation of fee templates and fee variables.
  The procedural chain checks for cyclic dependency."
  (:require [app.domain.fee.formula :as formula]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.util.util :as util]))

;; Fee Variables

(defn formula-tokens
  "Extract all variable tokens from template quantity and unit price formulas"
  [template]
  (->> [:fee-variable/fee-formula :fee-template/quantity-formula :fee-template/unit-price-formula]
       (mapcat #(some-> (% template) formula/tokenize))
       (filter #(str/starts-with? % ":"))
       (into #{})))


(defn fee-type-variable?
  "Is this a fee-type variable?"
  [variable]
  (= :fee-variable.source-type/fee
     (:fee-variable/source-type variable)))


(defn template-can-be-referenced?
  "Returns true if the template can be referenced by a fee-type variable."
  [template fee-variables]
  (let [tokens      (formula-tokens template)
        fee-var-ids (->> fee-variables
                         (filter fee-type-variable?)
                         (util/mapset :fee-variable/identifier))]
    (empty? (set/intersection tokens fee-var-ids))))


(defn get-referenceable-templates
  "Returns complete templates that can be referenced by fee-type variables"
  [fee-templates fee-variables]
  (->> fee-templates
       (filter #(template-can-be-referenced? % fee-variables))
       (util/mapset :db/id)))


;; Fee Templates

(defn- vec->search-map
  "Transform a vector of maps into a map with a specified key"
  ([coll]
   (vec->search-map coll :db/id identity))
  ([coll key-fn]
   (vec->search-map coll key-fn identity))
  ([coll key-fn val-fn]
   (into {} (map (juxt key-fn val-fn)) coll)))


(defn fee-cycle?
  [fee-templates fee-variables entity-id changes]
  (let [template-by-id (vec->search-map fee-templates)
        var-by-id      (vec->search-map fee-variables)
        var-by-name    (vec->search-map fee-variables :fee-variable/identifier)]
    (letfn [(get-all-tokens [eid]
              (let [node-map (if (= eid entity-id)
                               changes
                               (or (get template-by-id eid)
                                   (get var-by-id eid)
                                   {}))]
                (formula-tokens node-map)))

            (trace [eid visited path]
              (if (contains? visited eid)
                {:path path :cycle-at eid}
                (let [tokens (get-all-tokens eid)]
                  (some (fn [var-name]
                          (let [variable (get var-by-name var-name)
                                next-id  (or (get-in variable [:fee-variable/fee-template :db/id])
                                             (when (:fee-variable/fee-formula variable) (:db/id variable)))]
                            (when next-id
                              (trace next-id
                                     (conj visited eid)
                                     (conj path {:eid eid :var var-name})))))
                        tokens))))]
      (trace entity-id #{} []))))

(defn humanize-cycle-error
  "Format cycle result into a human-readable error."
  [{:keys [path cycle-at]} fee-templates]
  (let [template-name (vec->search-map fee-templates :db/id
                                       #(some :localized-string/text (:fee-template/titles %)))]
    [:error/fee-dependency-cycle (->> (conj path {:eid cycle-at})
                                      (mapcat (fn [{:keys [eid var]}] [(template-name eid) var]))
                                      (remove nil?)
                                      (str/join " -> "))]))
